const {paramStore} = require('../../../../stores');
const {INTERVAL_YEAR} = require('../constants/intervals');

module.exports = (interval = INTERVAL_YEAR) => paramStore('filter', {
  interval,
});
